'use client';
import * as Tooltip from '@radix-ui/react-tooltip';
import { CheckCircle, Grid, HexagonWithCheck, Loader } from 'phosphor-icons';
import { c } from '../../utils/tailwind-merge';
import { RichText } from '../RichText/RichText';
import { VerifiedSolutionProps } from './types';

export const VerifiedSolution = ({
  microcopy: {
    title = '',
    benefit1 = '',
    benefit2 = '',
    benefit3 = '',
    cta = '',
  },
  link = '',
  className = '',
}: VerifiedSolutionProps) => {
  return (
    <div className={c('rounded-sm text-white', className)}>
      <Tooltip.Provider>
        <Tooltip.Root delayDuration={0}>
          <Tooltip.Trigger asChild>
            <button className="IconButton">
              <HexagonWithCheck />
            </button>
          </Tooltip.Trigger>
          <Tooltip.Portal>
            <Tooltip.Content
              className="TooltipContent"
              sideOffset={5}
              side="bottom"
            >
              <div className="max-w-xs rounded-md bg-white p-4 shadow-card">
                <RichText html={title} className="text-sm" type="p" />
                <div className="px-3 py-2 pb-0">
                  <div className="flex items-start">
                    <CheckCircle
                      className="mr-3 mt-1 inline-block text-blue"
                      size={25}
                    />
                    <RichText
                      html={benefit1}
                      className="py-1.5 text-sm"
                      type="p"
                    />
                  </div>
                  <div className="flex items-start">
                    <div className="mr-1 pt-1">
                      <Loader />
                    </div>
                    <RichText
                      html={benefit2}
                      className="py-1.5 text-sm"
                      type="p"
                    />
                  </div>
                  <div className="flex items-start">
                    <div className="mr-1 pt-1">
                      <Grid />
                    </div>
                    <RichText
                      html={benefit3}
                      className="py-1.5 text-sm"
                      type="p"
                    />
                  </div>
                </div>
                <div className="mt-1 py-1">
                  <a href={link} className="text-sm text-blue hover:underline">
                    {cta}
                  </a>
                </div>
              </div>
              <Tooltip.Arrow width={14} height={8} style={{ fill: 'white' }} />
            </Tooltip.Content>
          </Tooltip.Portal>
        </Tooltip.Root>
      </Tooltip.Provider>
    </div>
  );
};
